import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, post, put, del } from '../api/client.js';

export function usePayRuns() {
  return useQuery({
    queryKey: ['pay', 'runs'],
    queryFn: async () => (await get('/api/pay/runs')).runs || [],
    staleTime: 30_000,
  });
}

export function usePayRun(id) {
  return useQuery({
    queryKey: ['pay', 'runs', id],
    queryFn: () => get(`/api/pay/runs/${id}`),
    enabled: !!id,
    staleTime: 15_000,
  });
}

export function useCreatePayRun() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => post('/api/pay/runs', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['pay', 'runs'] }),
  });
}

export function useUpdatePayRun() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) => put(`/api/pay/runs/${id}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['pay'] }),
  });
}

export function useDiscardPayRun() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => del(`/api/pay/runs/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['pay'] }),
  });
}

function payRunAction(action) {
  return function usePayRunAction() {
    const qc = useQueryClient();
    return useMutation({
      mutationFn: ({ id, ...body }) => post(`/api/pay/runs/${id}/${action}`, body),
      onSuccess: () => qc.invalidateQueries({ queryKey: ['pay'] }),
    });
  };
}
export const useApprovePayRun  = payRunAction('approve');
export const useReopenPayRun   = payRunAction('reopen');
export const useMarkPaid       = payRunAction('mark-paid');
export const useVoidPayRun     = payRunAction('void');

export function useUpdatePayItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) => put(`/api/pay/items/${id}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['pay', 'runs'] }),
  });
}
